<div>
    <div class="mt-3">
        @if(data?.codeBlocks?.length) {
            @for(item of data?.codeBlocks; track item?.title) {
                <div class="mb-2">
                    <app-code-snippet [displayAsCard]="true" [title]="item.title" [code]="item.code"></app-code-snippet>
                </div>
            }
        } @else {
            <app-code-snippet [displayAsCard]="true" [code]="data?.CodeSnippets"></app-code-snippet>
        }

    </div>
    <div class="card shadow rounded overflow-hidden mt-4">
        <div class="card-header-bg d-flex p-1">
            <span class="flex-grow-1 v-center mx-2"> Impacted Test Case Mappings  </span>
            <button class="btn-accello-primary p-1 px-3" [disabled]="!data?.mappings?.length"  (click)="onDownload()"> Download </button>
            
        </div>
        <app-zorro-table
        *ngIf="data?.mappings"
        tableId="imp-item"
        class="w-100"
        [columns]="tableColumns"
        [data]="data.mappings"
        (handleActions)="handleTableActions($event)">
        </app-zorro-table>
    </div>
    <div>

    </div>
</div>